import { useMemo, useCallback } from 'react';
import { useAuth } from 'hooks/useAuth/useAuth';
import { VEHICLE_TYPES } from 'utils/constants/vehicles';
import { useTranslation } from 'react-i18next';

export const useAssignment = (
  driverId,
  vehiclesIds = [],
  isTrailerJob = false
) => {
  const { profile } = useAuth();
  const availableDrivers = profile?.colleagues;
  const availableVehicles = profile?.vehicles;
  const { t } = useTranslation('PendingJobDetail');

  const findVehicle = useCallback(
    vehicleId => availableVehicles?.find(vehicle => vehicle.id === vehicleId),
    [availableVehicles]
  );

  const driverName = useMemo(() => {
    const driverAssign = availableDrivers?.find(
      driver => driver.id === driverId
    );
    return driverAssign?.contact_name || '';
  }, [availableDrivers, driverId]);

  const vehiclesPlates = useMemo(() => {
    return vehiclesIds.reduce((current, vehicleId, i) => {
      const vehicleAssign = findVehicle(vehicleId);
      const plateNumber = vehicleAssign?.plate_number || '';
      return (
        current + (i > 0 && plateNumber ? ' + ' + plateNumber : plateNumber)
      );
    }, '');
  }, [vehiclesIds, findVehicle]);

  const pendingVehicleLabel = useMemo(() => {
    if (!isTrailerJob && vehiclesIds.length > 0) return null;
    if (isTrailerJob && vehiclesIds.length === 1) {
      const vehicleType = findVehicle(vehiclesIds[0])?.vehicle_type;
      const labels = {
        [VEHICLE_TYPES.tractor_unit]: t('pendingTrailer'),
        [VEHICLE_TYPES.trailer]: t('pendingTractor')
      };
      return labels[vehicleType];
    }
  }, [isTrailerJob, t, vehiclesIds, findVehicle]);

  return {
    driverName,
    vehiclesPlates,
    pendingVehicleLabel,
    findVehicle
  };
};
